import codeTemplateRegistry from '../hardware-sensors/code-template-registry';

class BlockRegistry {
    static generators = {
        arduino: new Map(),
        python: new Map()
    };

    /**
     * @param {string} opcode 
     * @param {Function} fn - Generator function (block, context) => string
     */
    static register(opcode, fn) {
        if (this.generators.arduino.has(opcode)) {
            console.warn(`[BlockRegistry] Overriding existing Arduino generator for ${opcode}`);
        }
        this.generators.arduino.set(opcode, fn);
    }

    /**
     * @param {string} opcode 
     * @param {Function} fn - Generator function (block, context) => string
     */
    static registerPython(opcode, fn) {
        if (this.generators.python.has(opcode)) {
            console.warn(`[BlockRegistry] Overriding existing Python generator for ${opcode}`);
        }
        this.generators.python.set(opcode, fn);
    }

    /**
     * @param {Object} block 
     * @param {import('./GeneratorContext').default} context 
     * @returns {string}
     */
    static generate(block, context) {
        const targetLang = context.language || 'arduino';
        const generator = this.generators[targetLang].get(block.opcode);
        if (generator) {
            return generator(block, context);
        }

        // Fallback for hardware sensors using the old codeTemplateRegistry
        if (codeTemplateRegistry.has(block.opcode)) {
            const args = {};
            if (block.inputs) {
                for (const key of Object.keys(block.inputs)) {
                    args[key] = context.getInputValue(block, key);
                }
            }
            if (block.fields) {
                for (const key of Object.keys(block.fields)) {
                    args[key] = block.fields[key].value;
                }
            }

            const result = targetLang === 'arduino' 
                ? codeTemplateRegistry.generateArduino(block.opcode, args)
                : codeTemplateRegistry.generatePython(block.opcode, args);

            if (result) {
                if (result.includes) {
                    for (const inc of result.includes) context.addInclude(inc);
                }
                if (result.imports) {
                    for (const imp of result.imports) context.addInclude(imp);
                }
                if (result.declarations) {
                    for (const decl of result.declarations) context.addGlobal(decl, decl);
                }
                for (const setupLine of result.setup) context.addSetup(setupLine);
                return result.code;
            }
        }

        // Fallback for auto-extracting dropdown menu values
        if (block.opcode.includes('_menu_') && block.fields) {
            const fieldKeys = Object.keys(block.fields);
            if (fieldKeys.length > 0) {
                return block.fields[fieldKeys[0]].value;
            }
        }

        return `/* unsupported: ${block.opcode} in ${targetLang} */ 0`;
    }

    static has(opcode, targetLang = 'arduino') {
        return this.generators[targetLang].has(opcode);
    }
}

export default BlockRegistry;
